import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { GridModule, ExcelModule } from "@progress/kendo-angular-grid";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { BuildingBlocksModule } from '@gbs-platform-client/building-blocks';
import { ConfigService } from '@gbs-platform-client/fwk-core';
import { PageheaderComponent } from './utils/elements/pageheader/pageheader.component';
import { LoginComponent } from './authentication/pages/login/login.component';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { AppRoutingModule } from './routing/route-module';
import { LandingpageComponent } from './dashboards/landingpage/landingpage.component';
import { LocationComponent } from './mds/settings/pages/location/location.component';
import { ModuleComponent } from './mds/settings/pages/module/module.component';
import { DepartmentComponent } from './mds/settings/pages/department/department.component';
import { CompanyComponent } from './mds/settings/pages/company/company.component';
import { DivisionComponent } from './mds/settings/pages/division/division.component';
import { ExpenseHeadComponent } from './mds/settings/pages/expensehead/expensehead.component';
import { SubDepartmentComponent } from './mds/settings/pages/subdepartment/subdepartment.component';
import { RolemasterComponent } from './mds/settings/pages/rolemaster/rolemaster.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { LandingMenuComponent } from './utils/elements/landing-menu/landing-menu.component';
import { SidebarComponent } from './utils/elements/sidebar/sidebar.component';
import { MenuComponent } from "./mds/settings/pages/menu/menu.component";
import { MainMenuComponent } from './utils/elements/menu/mainmenu.component'
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
// import { EditorModule } from '@progress/kendo-angular-editor';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AddUserComponent } from './mds/settings/pages/add-user/add-user.component';
import { ForgotpwdComponent } from './mds/settings/pages/forgotpwd/forgotpwd.component';
import { PasswordresetComponent } from './mds/settings/pages/passwordreset/passwordreset.component';
import { AdminPortalComponent } from './mds/settings/pages/admin-portal/admin-portal.component';
import { DesignationComponent } from './mds/settings/pages/designation/designation.component';
import { UnitComponent } from './mds/settings/pages/unit/unit.component';
import { CommitteeComponent } from "./mds/settings/pages/committee/committee.component";
import { EmployeeComponent } from './mds/settings/pages/employee/employee.component';
import { CurrencyComponent } from './mds/settings/pages/currency/currency.component';
import { DesignationLevelComponent } from './mds/settings/pages/designationlevel/designationlevel.component';
import { CurrencyUnitComponent } from './mds/settings/pages/currencyunit/currencyunit.component';
import { FinYearComponent } from './mds/settings/pages/finyear/finyear.component';
import { DelegationComponent } from './mds/settings/pages/delegation/delegation.component';
import { MeetingmasterComponent } from './mds/settings/pages/meetingmaster/meetingmaster.component';
import { MeetingtypeComponent } from './mds/settings/pages/meetingtype/meetingtype.component';
import { PurposeComponent } from './mds/settings/pages/purpose/purpose.component';
import { VenueComponent } from './mds/settings/pages/venue/venue.component';
import { ActComponent } from './mds/settings/pages/act/act.component';
import { FacilityComponent } from './mds/settings/pages/facility/facility.component';
import { FacilityManagerComponent } from './mds/settings/pages/facilitymanager/facilitymanager.component';
import { SectionComponent } from './mds/settings/pages/section/section.component';
import { AgendaPriorityComponent } from './mds/settings/pages/agendapriority/agendapriority.component';
import { InviteeTypeComponent } from './mds/settings/pages/inviteetype/inviteetype.component';
import { PositionComponent } from './mds/settings/pages/position/position.component';
import { ZoneComponent } from './mds/settings/pages/zone/zone.component';
import { StateComponent } from './mds/settings/pages/state/state.component';
import { RegionComponent } from './mds/settings/pages/region/region.component';
import { ClusterComponent } from './mds/settings/pages/cluster/cluster.component';
import { DirectorComponent } from './mds/settings/pages/director/director.component';
import { ParentdepartmentComponent } from './mds/settings/pages/parentdepartment/parentdepartment.component';
import { WorkflowComponent } from './mds/settings/pages/workflow/workflow.component';
import { AuthInterceptor } from './mds/settings/services/interceptor'


@NgModule({
  declarations: [
    AdminPortalComponent,
    AppComponent,
    LoginComponent,
    DashboardComponent,
    LandingpageComponent,
    PageheaderComponent,
    ModuleComponent,
    LocationComponent,
    RolemasterComponent,
    DepartmentComponent,
    MainMenuComponent,
    SidebarComponent,
    MenuComponent,
    LandingMenuComponent,
    AddUserComponent,
    ForgotpwdComponent,
    PasswordresetComponent,
    CompanyComponent,
    DivisionComponent,
    ExpenseHeadComponent,
    SubDepartmentComponent,
    DesignationComponent,
    UnitComponent,
    CommitteeComponent,
    EmployeeComponent,
    CurrencyComponent,
    DesignationLevelComponent,
    CurrencyUnitComponent,
    FinYearComponent,
    DelegationComponent,
    MeetingmasterComponent,
    MeetingtypeComponent,
    PurposeComponent,
    VenueComponent,
    ActComponent,
    SectionComponent,
    FacilityComponent,
    FacilityManagerComponent,
    AgendaPriorityComponent,
    InviteeTypeComponent,
    PositionComponent,
    ZoneComponent,
    StateComponent,
    RegionComponent,
    ClusterComponent,
    DirectorComponent,
    ParentdepartmentComponent,
    WorkflowComponent
  ],

  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    GridModule,
    GaugesModule,
    BuildingBlocksModule,
    NotificationModule,
    DialogModule,
    ChartsModule,
    // EditorModule,
    InputsModule,
    LabelModule,
    DateInputsModule,
    IntlModule,
    ExcelExportModule,
    ExcelModule,
    PopupModule,
    DropDownsModule
  ],

  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.loadConfig(),
      deps: [ConfigService],
      multi: true
    },
    {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
